// import { toBase64 } from '@/helpers'

export const apificate = (state) => (payload) => {
  let response = {}
  response[payload] = state[payload]
  // if (payload === 'logofile') response['logofile'] = toBase64(state[payload])
  // if (payload === 'xsltfile') response['xsltfile'].file = toBase64(state[payload].file)
  return response
}
